'use strict';

import template from '../../templates/employees/Main.ejs';
import EmployeeView from './Employee';
import PaginatedList from 'commons/views/PaginatedList.js';
import loader from 'helpers/loader';

module.exports = PaginatedList.extend({
    views: [],
    events() {
        let parentEvents = _.isFunction(PaginatedList.prototype.events) ?
            PaginatedList.prototype.events() :
            PaginatedList.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-back': 'back'
        });
    },

    initialize(options) {
        this.options = _.defaults(options || {}, {
            company: null
        });

        this.views = [];

        this.collection.on('sync', this.render, this);
        this.collection.fetchPage(undefined, {validate: false});
        this.stopLoader = loader.startFullPage(this.$('table'));

        return this;
    },

    render() {
        this.$el.html(template({
            company:    this.options.company,
            searchTerm: this.collection.getSearchTerm(),
            total:      this.collection.length,
            pagination: this.collection.getPaginationInfo(),
            sort:       this.collection.getSort()
        }));

        this.collection.forEach(employee => {
            this.views.push(new EmployeeView({model: employee}));

            this.$('.js-employees').append(_(this.views).last().$el);
        });

        this.stopLoader();
        return this;
    },

    back() {
        if (!this.options.company) {
            return;
        }

        history.go(-1);
    },

    navigate() {
        app.mainRouter.navigate('employees/' +
            (this.options.company ? this.options.company.id : 'all') +
            (
                this.collection.getSearchTerm() ?
                '/' + this.collection.getSearchTerm() : ''
            ), {trigger: true});
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/employees/Main.js